import React, { Fragment } from 'react';
import { instanceOf, shape, func, bool } from 'prop-types';
import DefinitionTable from './DefinitionTable';
import { getWarnings } from '../../../../../util/deUtils';
import WarningToast from '../../../shared/WarningToast';

const SelectionView = ({ studyDefinition, setSelectedDefinition, isLatestStudy }) => {
  const selectedFolder = studyDefinition.studyTargets.find(
    item => item.isActive
  );
  if (!studyDefinition.available || !selectedFolder) {
    return (
      <div className="de--def--no-record">
        Once a folder has been selected this section will display available
        definitions.
      </div>
    );
  }
  
  if (!studyDefinition.available[selectedFolder.uniqueId]) {
    return <div style={{ padding: 20 }}>Loading...</div>;
  }
  if (studyDefinition.available[selectedFolder.uniqueId] &&
    studyDefinition.available[selectedFolder.uniqueId].data.length === 0) {
    return <div className="de--def--list-empty">No Definitions to display</div>;
  }
  const definitionListObj = studyDefinition.available[selectedFolder.uniqueId];
  const warnings = getWarnings(definitionListObj, isLatestStudy);

  return (
    <Fragment>
      {warnings.map(warning => (
        <WarningToast
          title={warning.title}
          message={warning.message}
          key={warning.title}
        />
      ))}
      <DefinitionTable
        studyDefinition={{
          definitionList: definitionListObj,
        }}
        setSelectedDefinition={setSelectedDefinition}
      />
    </Fragment>
  );
};

SelectionView.propTypes = {
  studyDefinition: shape({
    available: instanceOf(Object),
  }),
  setSelectedDefinition: func,
  isLatestStudy:bool,
};

SelectionView.defaultProps = {
  studyDefinition: {
    studyTargets: [],
    available: null,
  },
};

export default SelectionView;
